import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconGlassWater: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconGlassWater"><Path fillRule="evenodd" clipRule="evenodd" d="M17.8457 21H6.16602L3.90625 3H20.1055L17.8457 21ZM6.10938 8.5127C8.2127 7.96341 10.2806 8.39116 12.1494 8.76465C14.2091 9.17629 16.043 9.52602 17.8486 8.93945L18.4062 4.5H5.60547L6.10938 8.5127Z" fill="currentColor"/></CentralIconBase>;
});

export default IconGlassWater;
